var _style, _path, _path2, _path3, _path4, _line, _path5, _path6, _path7, _path8, _line2, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53 54.2",
    style: {
      enableBackground: "new 0 0 53 54.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFB600;}\n\t.st1{fill:#ABABAB;stroke:#ABABAB;stroke-miterlimit:10;}\n\t.st2{fill:#104C90;}\n\t.st3{fill:#FFB600;stroke:#FFB600;stroke-width:0.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,44.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.1,32.8l-2,0.6c-3.3-5.9-11.9-11.4-21.8-8.4c-4.7,1.4-8.3,4.3-10.8,8.4C3.9,36,3,38.9,2.9,42 c9.6,0,19.2,0,28.8,0l-0.1,2.1c-1.9,0-3.7,0-5.5,0c-7.9,0-15.9,0-23.8,0c-1.2,0-1.6-0.3-1.5-1.5c0.2-9,6.1-16.9,14.9-19.7 c0.2-0.1,0.4-0.1,0.7-0.2c-3.9-2.4-6-5.8-6-10.3c0-3.3,1.3-6.1,3.7-8.3c4.8-4.5,12.4-4,16.6,0.9c4.7,5.4,3.4,14-3.2,17.8 c0.5,0.2,1,0.3,1.4,0.5c4.9,1.8,8.7,4.9,11.3,9.4 M21.8,22c5.3,0,9.5-4.2,9.5-9.4c0-5.2-4.2-9.5-9.5-9.5c-5.1,0-9.4,4.3-9.4,9.4 C12.3,17.7,16.5,21.9,21.8,22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.4,47.2c-0.4,0-0.7-0.2-1.2-0.6c-0.7-0.7-1.4-1.4-2.1-2.1c-0.7-0.7-0.7-1.4-0.1-2c0.3-0.3,0.6-0.4,0.9-0.4 c0,0,0,0,0,0c0.4,0,0.8,0.2,1.1,0.5c0.4,0.4,0.7,0.7,1.1,1.1l0.3,0.3l4.2-4.2c0.5-0.5,0.9-0.7,1.3-0.7c0,0,0,0,0,0 c0.3,0,0.6,0.1,0.9,0.4c0.9,0.9,0,1.8-0.3,2.1c-1.6,1.6-3.3,3.3-4.9,4.9C41.1,47,40.8,47.2,40.4,47.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "V2NCop_1_"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 512,
    height: 512,
    id: "V2NCop_2_",
    xlinkHref: "82978D6BBBF772B3.png",
    transform: "matrix(1 0 0 1 179.3855 -351.7944)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 31.9,
    y1: 44.2,
    x2: 31.9,
    y2: 42
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.9,42c0.2-1.9,0.9-3.6,2-5c1.2-1.5,2.6-2.6,4.4-3.3l2.5-0.6c0.1,0,0.2,0,0.4,0c5.5-0.5,10.2,3.5,10.8,9.1 c0.6,5.2-3.3,10.2-8.6,10.9C37.9,53.8,33,50.2,32,44.9c0-0.2-0.1-0.4-0.1-0.7L31.9,42z M34,43.1c0,4.4,3.6,8,8,8c4.4,0,8-3.6,7.9-8 c0-4.4-3.6-7.9-7.9-7.9c-1.6,0-3.2,0.5-4.5,1.4C35.4,37.9,34,40.4,34,43.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.9,44.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.9,42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.1,33.3c-3.3-5.9-11.9-11.4-21.8-8.4c-4.7,1.4-8.3,4.3-10.8,8.4C3.9,36,3,38.9,2.9,42c9.6,0,19.2,0,28.8,0 l-0.1,2.1c-1.9,0-3.7,0-5.5,0c-7.9,0-15.9,0-23.8,0c-1.2,0-1.6-0.3-1.5-1.5c0.2-9,6.1-16.9,14.9-19.7c0.2-0.1,0.4-0.1,0.7-0.2 c-3.9-2.4-6-5.8-6-10.3c0-3.3,1.3-6.1,3.7-8.3c4.8-4.5,12.4-4,16.6,0.9c4.7,5.4,3.4,14-3.2,17.8c0.5,0.2,1,0.3,1.4,0.5 c4.9,1.8,8.7,4.9,11.3,9.4L38.1,33.3z M21.8,22c5.3,0,9.5-4.2,9.5-9.4c0-5.2-4.2-9.5-9.5-9.5c-5.1,0-9.4,4.3-9.4,9.4 C12.3,17.7,16.5,21.9,21.8,22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "V2NCop_3_"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 512,
    height: 512,
    id: "V2NCop_4_",
    xlinkHref: "82978D6BBBF772BA.png",
    transform: "matrix(1 0 0 1 179.3855 -351.7944)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 31.9,
    y1: 44.2,
    x2: 31.9,
    y2: 42
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.9,42c0.2-1.9,0.9-3.6,2-5c1.2-1.5,2.6-2.6,4.4-3.3l2.5-0.6c0.1,0,0.2,0,0.4,0c5.5-0.5,10.2,3.5,10.8,9.1 c0.6,5.2-3.3,10.2-8.6,10.9C37.9,53.8,33,50.2,32,44.9c0-0.2-0.1-0.4-0.1-0.7L31.9,42z M34,43.1c0,4.4,3.6,8,8,8c4.4,0,8-3.6,7.9-8 c0-4.4-3.6-7.9-7.9-7.9c-1.6,0-3.2,0.5-4.5,1.4C35.4,37.9,34,40.4,34,43.1z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,47.2c-0.4,0-0.7-0.2-1.2-0.6c-0.7-0.7-1.4-1.4-2.1-2.1c-0.7-0.7-0.7-1.4-0.1-2c0.3-0.3,0.6-0.4,0.9-0.4 c0.4,0,0.8,0.2,1.1,0.5c0.4,0.4,0.7,0.7,1.1,1.1c0.4,0.4,0.7,0.7,1.1,1.1c0.1,0.2,0.3,0.3,0.4,0.5C42.1,46.2,41.4,47.2,40.4,47.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.c8fe974129284db2c5f0dd571364bb7e.svg";
export { ForwardRef as ReactComponent };